module.exports = __webpack_public_path__ + "static/media/qualitas-thumbsup.810231df.svg";